import { render, staticRenderFns } from "./PartOne.vue?vue&type=template&id=0395e48d&scoped=true"
import script from "./PartOne.vue?vue&type=script&lang=js"
export * from "./PartOne.vue?vue&type=script&lang=js"
import style0 from "./PartOne.vue?vue&type=style&index=0&id=0395e48d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_vue-template-compiler@2.6.14_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0395e48d",
  null
  
)

export default component.exports